
















import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { stopBodyScroll } from '@utils/index'
import { Overlay } from 'vant'

@Component({
  components: {
    [Overlay.name]: Overlay
  }
})
export default class AgeSelectDialogNoLogin extends Vue {
  @Prop({ default: false }) readonly show!: boolean
  @Prop({ default: () => null }) readonly selectedBaby!: any
  list = [
    { age: '怀孕中', type: 1 },
    { age: '0-1岁', type: 2 },
    { age: '1岁', type: 2 },
    { age: '2岁', type: 2 },
    { age: '3岁', type: 2 },
    { age: '4岁', type: 3 },
    { age: '5岁', type: 3 },
    { age: '6岁', type: 3 },
    { age: '6岁以上', type: 3 }
  ]


  close(e:MouseEvent ){
    const target = e.target as HTMLElement
    if(target.className === 'wrapper'){
        this.$emit('hide')
    }
  }

  @Watch('show')
  onChangeShow(val: boolean) {
    stopBodyScroll(val)
  }
}
